// Mitä ruutujen muodoista piirretään kartalle (MapView.jsx piirtää; tämä päättää mitä ja missä järjestyksessä).
//
// Pikkuruuduilla (zoom 17) on kolme erillistä kytkintä: maksimiklusteri ja -neliö (`shapes`) sekä seuraavan neliön
// puuttuvat ruudut (`next`). Suurilla ruuduilla (zoom 14, noin 1,2 km) on yksi kytkin (`shapesLarge`), koska
// suuria ruutuja on vähän: sama kytkin näyttää klusterin, neliön ja seuraavan neliön tavoitteen. Pikkuruutujen
// kytkimet eivät vaikuta suuriin eikä päinvastoin.

import { squareBounds, tileBounds } from "./geo.js";

/**
 * Piirrettävät kohteet järjestyksessä (alin ensin).
 * Jokainen: { level: "small" | "large", part: "cluster" | "square" | "missing" | "target", bounds }
 *   - cluster / missing: yksi ruutu; square / target: koko neliön ääriviiva.
 */
export function shapePrimitives(shapes, overlays) {
  const out = [];
  const small = shapes?.small;
  if (small && overlays?.shapes) {
    for (const key of small.cluster?.tiles ?? []) out.push({ level: "small", part: "cluster", bounds: tileBounds(key) });
    const sq = small.square;
    if (sq) out.push({ level: "small", part: "square", bounds: squareBounds(small.zoom, sq.x0, sq.y0, sq.size) });
  }
  if (small?.next_square && overlays?.next) {
    const next = small.next_square;
    for (const key of next.missing) out.push({ level: "small", part: "missing", bounds: tileBounds(key) });
    out.push({ level: "small", part: "target", bounds: squareBounds(small.zoom, next.x0, next.y0, next.size) });
  }
  const large = shapes?.large;
  if (large && overlays?.shapesLarge) {
    for (const key of large.cluster?.tiles ?? []) out.push({ level: "large", part: "cluster", bounds: tileBounds(key) });
    for (const key of large.next_square?.missing ?? []) out.push({ level: "large", part: "missing", bounds: tileBounds(key) });
    if (large.square) out.push({ level: "large", part: "square", bounds: squareBounds(large.zoom, large.square.x0, large.square.y0, large.square.size) });
    const next = large.next_square;
    if (next) out.push({ level: "large", part: "target", bounds: squareBounds(large.zoom, next.x0, next.y0, next.size) });
  }
  return out;
}

/** Tarvitseeko jokin päällä oleva kerros muotolaskentaa? (Passin kortti tarvitsee sen aina.) */
export const shapesWanted = (overlays) => Boolean(overlays?.shapes || overlays?.next || overlays?.shapesLarge);

/**
 * Selitteen rivit päällä oleville muodoille. Pikkuruutujen rivit ovat ennallaan (tyylit sw-cluster ym.);
 * suurille omat rivit, jotta ne erottaa pienistä.
 */
export function shapeLegend(overlays) {
  const rows = [];
  if (overlays?.shapes) rows.push({ cls: "sw-cluster", text: "Maksimiklusteri" }, { cls: "sw-square", text: "Maksimineliö" });
  if (overlays?.next) rows.push({ cls: "sw-next", text: "Seuraavan neliön puuttuvat" });
  if (overlays?.shapesLarge) {
    rows.push({ cls: "sw-lcluster", text: "Suurten ruutujen klusteri" }, { cls: "sw-lsquare", text: "Suurten ruutujen neliö" }, { cls: "sw-lnext", text: "Suurten ruutujen tavoite" });
  }
  return rows;
}
